import React, { useState } from "react";
import PrivateMsg from "./PrivateMsg/PrivateMsg";
import Tabs from "../../../components/tabs/Tabs";
import ChatRoom from "./ChatRoom/ChatRoom";
import VendorMsg from "./VendorMsg/VendorMsg";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import { useLocation } from "react-router-dom";

const Inbox = () => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const { state } = useLocation();

  const items = [
    role !== roles.coHost && {
      key: "1",
      label: "Private Message",
      children: (
        <>
          <PrivateMsg
            chatData={state?.chatData}
            screen={state?.screenType}
            activeKey={state?.activeKey}
          />
        </>
      ),
    },
    role !== roles.coHost && {
      key: "2",
      label: "Chat Room",
      children: <ChatRoom />,
    },
    role !== roles.vendor &&
      role !== roles.guest &&
      role !== roles.staff && {
        key: "3",
        label: "Vendor Message",
        children: (
          <VendorMsg
            chatData={state?.chatData}
            screen={state?.screenType}
            activeKey={state?.activeKey}
          />
        ),
      },
  ];
  console.log("activeKeyasdasdasdasdadasd", state?.activeKey);
  // const [selectedTab, setSelectedTab] = useState(tabLinks[2].title);
  return (
    <>
      {/* {role == roles.vendor ? (
        <PrivateMsg />
      ) : ( */}
      <BoxTabs
        items={items}
        destroyOnBlur={true}
        activeKey={state?.activeKey}
        changeHeaderOnTab
      />
      {/* )} */}
    </>
  );
};

export default Inbox;
